// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.number-input {
  border-radius: 40px;
  border-color: var(--ion-color-medium-tint) !important;
  border: 1px;
  border-style: solid;
  padding-left: calc(8 * var(--width-ratio));
  padding-right: calc(8 * var(--width-ratio));
}

.number-input.small {
  width: calc(115 * var(--width-ratio));
  height: calc(30 * var(--width-ratio));
}

.number-input.large {
  width: calc(207 * var(--width-ratio));
  height: calc(40 * var(--width-ratio));
}

.quantity {
  height: calc(16 * var(--width-ratio));
  text-align: center;
  margin: auto;
  background: white;
  border: 0;
  border-left: 1px;
  border-left-color: var(--ion-color-medium-tint);
  border-left-style: solid;
  border-right: 1px;
  border-right-color: var(--ion-color-medium-tint);
  border-right-style: solid;
}

.quantity.small {
  width: calc(48 * var(--width-ratio));
}

.quantity.large {
  width: calc(131 * var(--width-ratio));
}

.mybutton {
  height: unset;
  margin: unset;
  --padding-start: unset;
  --padding-end: unset;
}
.mybutton ion-icon {
  width: calc(20 * var(--width-ratio));
  height: calc(20 * var(--width-ratio));
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/number-picker/number-picker.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,qDAAA;EACA,WAAA;EACA,mBAAA;EACA,0CAAA;EACA,2CAAA;AACF;;AAEA;EACE,qCAAA;EACA,qCAAA;AACF;;AAEA;EACE,qCAAA;EACA,qCAAA;AACF;;AAEA;EACE,qCAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EAEA,SAAA;EACA,gBAAA;EACA,+CAAA;EACA,wBAAA;EACA,iBAAA;EACA,gDAAA;EACA,yBAAA;AAAF;;AAEA;EACE,oCAAA;AACF;;AACA;EACE,qCAAA;AAEF;;AACA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;AAEF;AAAE;EACE,oCAAA;EACA,qCAAA;AAEJ","sourcesContent":[".number-input {\n  border-radius: 40px;\n  border-color: var(--ion-color-medium-tint) !important;\n  border: 1px;\n  border-style: solid;\n  padding-left: calc(8 * var(--width-ratio));\n  padding-right: calc(8 * var(--width-ratio));\n}\n\n.number-input.small {\n  width: calc(115 * var(--width-ratio));\n  height: calc(30 * var(--width-ratio));\n}\n\n.number-input.large {\n  width: calc(207 * var(--width-ratio));\n  height: calc(40 * var(--width-ratio));\n}\n\n.quantity {\n  height: calc(16 * var(--width-ratio));\n  text-align: center;\n  margin: auto;\n  background: white;\n\n  border: 0;\n  border-left: 1px;\n  border-left-color: var(--ion-color-medium-tint);\n  border-left-style: solid;\n  border-right: 1px;\n  border-right-color: var(--ion-color-medium-tint);\n  border-right-style: solid;\n}\n.quantity.small {\n  width: calc(48 * var(--width-ratio));\n}\n.quantity.large {\n  width: calc(131 * var(--width-ratio));\n}\n\n.mybutton {\n  height: unset;\n  margin: unset;\n  --padding-start: unset; // 看情況是否右邊要padding否\n  --padding-end: unset; // 看情況是否左邊要padding否\n\n  ion-icon {\n    width: calc(20 * var(--width-ratio));\n    height: calc(20 * var(--width-ratio));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
